<app-titolo-subtitolo
  [titolo]="'Analisi di Doppia Materialità'"
  [paddingTop]="10"
  [isArchiviato]="isArchiviato()"
></app-titolo-subtitolo>

<div mat-dialog-content class="dialog-center-cont" style="padding: 0px !important">
  <app-spinner-overlay></app-spinner-overlay>
  <mat-stepper [linear]="true" #stepper (selectionChange)="cambioStep($event)">
    <mat-step [stepControl]="formDoppiaMaterialitaCheckId" [editable]="true">
      <ng-template matStepLabel> Doppia Materialità </ng-template>
      <ng-scrollbar>
        <form
          [formGroup]="formDoppiaMaterialita"
          appFormContainer
          [larghezza]="6"
          [rowGap]="10"
          style="align-items: center"
        >
          <div appFormElement [larghezza]="6" [riempi]="true">
            <div class="titolo-sezione-dialog">Creazione Analisi di Doppia Materialità</div>

            <div class="descrizione-sezione-dialog">
              Inserisci il titolo e l’anno di riferimento e scegli tra l’approccio generico e quello
              settoriale.
            </div>
          </div>

          <mat-form-field appFormElement [larghezza]="2" class="input-form">
            <mat-label>Titolo</mat-label>
            <input matInput placeholder="Titolo" formControlName="titolo" />
            <mat-error appFormError></mat-error>
          </mat-form-field>

          <mat-form-field appFormElement [larghezza]="2" [riempi]="true" [minWidth]="150">
            <mat-label>Anno</mat-label>
            <mat-select formControlName="anno" placeholder="Anno">
              <mat-option
                *ngFor="let aa of arrayAnni"
                [value]="aa"
                [disabled]="ctrAnnoMaterialitaUtilizzata(aa)"
                >{{ aa }}</mat-option
              >
            </mat-select>
          </mat-form-field>

          <div appFormElement [larghezza]="2" style="display: flex; flex-direction: column">
            <mat-label>Framework</mat-label>
            <mat-radio-group
              class="radio-tipo-sett"
              aria-label="Framework"
              formControlName="tipoSettore"
            >
              <div class="radio-container">
                <mat-radio-button
                  aria-label="Generico"
                  value="GENERALE"
                  [disabled]="this.formDoppiaMaterialita.get('id')?.value || !this.settoreGenerale"
                >
                  Generale
                </mat-radio-button>
                <div class="eti-check">
                  <mat-icon matTooltip="Adatto ad aziende di ogni settore" class="info-icon">
                    info_outline
                  </mat-icon>
                </div>
              </div>

              <div class="radio-container">
                <mat-radio-button
                  aria-label="Specifico"
                  value="SPECIFICO"
                  [disabled]="
                    this.formDoppiaMaterialita.get('id')?.value || !this.settoriAzienda.length
                  "
                >
                  Settoriale
                </mat-radio-button>
                @if (!this.formDoppiaMaterialita.get('id')?.value && !this.settoriAzienda.length) {
                  <div class="eti-check">
                    <mat-icon matTooltip="Estensione settoriale non attiva" class="info-icon">
                      info_outline
                    </mat-icon>
                  </div>
                } @else {
                  <div class="eti-check">
                    <mat-icon
                      matTooltip="Sviluppato ad hoc per il settore di appartenenza dell'azienda"
                      class="info-icon"
                    >
                      info_outline
                    </mat-icon>
                  </div>
                }
              </div>
            </mat-radio-group>
          </div>

          <mat-form-field
            appFormElement
            [larghezza]="3"
            class="input-form"
            *ngIf="this.formDoppiaMaterialita.get('tipoSettore')?.value === 'SPECIFICO'"
          >
            <mat-label>Settore</mat-label>
            <mat-select formControlName="settori" placeholder="Settore" [compareWith]="compareById">
              <mat-option
                *ngFor="let set of settoriAzienda"
                [value]="set"
                [disabled]="ctrSettoreMaterialitaUtilizzata(set)"
                >{{ set.titolo }}</mat-option
              >
            </mat-select>
          </mat-form-field>

          <mat-form-field
            appFormElement
            [larghezza]="3"
            class="input-form"
            *ngIf="
              this.formDoppiaMaterialita.get('tipoSettore')?.value === 'SPECIFICO' &&
              arraySottoSettori?.length
            "
          >
            <mat-label>Sotto-settori</mat-label>
            <mat-select
              formControlName="sottoSettori"
              placeholder="Sotto-settori"
              [compareWith]="compareById"
              multiple
            >
              <mat-option *ngFor="let sottoSet of arraySottoSettori" [value]="sottoSet">{{
                sottoSet.titolo
              }}</mat-option>
            </mat-select>
          </mat-form-field>

          <div appFormElement [larghezza]="6">
            <app-separatore-label
              [styleSeparatore]="'small'"
              [spazioDestra]="0"
              [spazioSinistra]="0"
            ></app-separatore-label>
          </div>

          <div appFormElement [larghezza]="6" [riempi]="true">
            <div class="titolo-sezione-dialog">
              Inserisci dati sul fatturato e il numero di dipendenti
            </div>

            <div class="descrizione-sezione-dialog">
              Completa i campi su fatturato e numero di dipendenti per continuare l'analisi.
            </div>
          </div>

          <mat-form-field appFormElement [larghezza]="3" [riempi]="true">
            <mat-label>Fatturato</mat-label>
            <input
              matInput
              placeholder="Fatturato"
              formControlName="fatturato"
              type="number"
              appInputNumber
              inputmode="numeric"
              min="0"
              max="999999999999"
              (keydown)="onKeyDown($event)"
            />
            <mat-error appFormError></mat-error>
          </mat-form-field>

          <mat-form-field appFormElement [larghezza]="3" [riempi]="true">
            <mat-label>Nr. Dipendenti</mat-label>
            <input
              matInput
              placeholder="Nr. Dipendenti"
              formControlName="nrDipendenti"
              type="number"
              appInputNumber
              min="0"
              max="999999999999"
              (keydown)="onKeyDownDip($event)"
              inputmode="numeric"
            />
            <mat-error appFormError></mat-error>
          </mat-form-field>
        </form>
      </ng-scrollbar>
    </mat-step>

    <mat-step [stepControl]="formDoppiaMaterialitaCheckId" [editable]="true">
      <ng-template matStepLabel> Tematiche </ng-template>
      <ng-scrollbar>
        <div appFormElement [larghezza]="6" [riempi]="true">
          <div class="titolo-sezione-dialog">Selezione delle tematiche</div>

          <div class="descrizione-sezione-dialog">
            Seleziona le tematiche rilevanti per la tua analisi di materialità. Puoi mappare ogni
            tematica agli standard ESRS per garantire un allineamento con la normativa. Solo le
            tematiche selezionate verranno utilizzate nei passaggi successivi per la valutazione di
            impatti, rischi e opportunità.
          </div>
        </div>
        <!-- CONTENT -->

        <app-cfg-questionario
          #surveyComp
          [isPermessoSoloRead]="isPermessoSoloRead"
          [tipoQuestionario]="'DOPPIA_MATERIALITA'"
          [cfgQuestionario]="survey"
          [idSostenibilita]="formDoppiaMaterialita.get('id')?.value"
          [nascondiTitolo]="true"
          [disabled]="this.formDoppiaMaterialita.get('statoDm')?.value !== 'NON_INVIATO'"
        >
        </app-cfg-questionario>
      </ng-scrollbar>
    </mat-step>

    <!-- STEP IRO -->
    <mat-step [stepControl]="formDoppiaMaterialitaCheckId" [editable]="true">
      <ng-template matStepLabel> IRO </ng-template>

      <div>
        <div class="titolo-sezione-dialog">Impatti, Rischi e Opportunità</div>

        <div class="descrizione-sezione-dialog">
          Seleziona impatti, rischi e opportunità legati alla tematica
        </div>
      </div>
      <!-- CONTENT -->
      @if (strutturaEsrsPerIro.length) {
        <mat-tab-group class="iro">
          @for (ambito of strutturaEsrsPerIro; track ambito.id) {
            <mat-tab [label]="ambito.titoloBreve">
              <ng-scrollbar>
                <div class="listcontainer">
                  <mat-accordion class="lista-iro" multi>
                    @for (tematica of ambito.tematiche; track tematica.id) {
                      <mat-expansion-panel
                        [expanded]="true"
                        class="albero-iro"
                        [disabled]="tematica.esrs === undefined || tematica.esrs.length <= 0"
                      >
                        <mat-expansion-panel-header
                          class="tematica"
                          [class.dettaglio]="
                            tematica.esrs === undefined || tematica.esrs.length <= 0
                          "
                        >
                          <mat-panel-title>
                            @if (tematica.idAzienda) {
                              <span
                                class="badge-tematica-aziendale"
                                matTooltip="Tematica aziendale"
                              >
                                Aziendale
                              </span>
                            }
                            Tematica -
                            {{ tematica.domanda }}
                          </mat-panel-title>

                          <ng-container
                            *ngIf="tematica.esrs === undefined || tematica.esrs.length <= 0"
                            [ngTemplateOutlet]="bottoni"
                            [ngTemplateOutletContext]="{ ambito, tematica: tematica }"
                          >
                          </ng-container>
                        </mat-expansion-panel-header>

                        <div class="temi">
                          @for (tema of tematica.esrs; track tema.id) {
                            <ng-container
                              [ngTemplateOutlet]="temaEsrs"
                              [ngTemplateOutletContext]="{ ambito, tematica, tema, livello: 1 }"
                            ></ng-container>
                          }
                        </div>
                      </mat-expansion-panel>
                    }
                  </mat-accordion>
                </div>
              </ng-scrollbar>
            </mat-tab>
          }
        </mat-tab-group>
      }
    </mat-step>

    <mat-step [stepControl]="formDoppiaMaterialitaCheckId" [editable]="true">
      <ng-template matStepLabel> Validatori IRO </ng-template>

      <div style="height: 10px"></div>
      <app-seleziona-stakeholders
        [tipo]="'INTERNI'"
        #validatoriIro
        [idMaterialita]="this.formDoppiaMaterialita.get('id')?.value"
        [disabled]="
          this.formDoppiaMaterialita.get('statoDm')?.value === 'APPROVATO' ||
          this.formDoppiaMaterialita.get('statoDm')?.value === 'IN_VALIDAZIONE'
        "
        [gestionePeso]="false"
        [getStakeholdersFn]="getValidatori"
        [salvaStakeholdersFn]="salvaValidatori"
      >
        <div class="titolo-sezione-dialog">Validatori IRO</div>

        <div class="descrizione-sezione-dialog">
          Definizione Validatori Impatti, Rischi e Opportunità.<br />
          Dalla seguente lista di Stakeholder Interni seleziona i Validatori IRO, coloro che avranno
          il ruolo di validare impatti, rischi e opportunità (IRO) individuati nell'analisi.
        </div>
      </app-seleziona-stakeholders>
    </mat-step>

    <mat-step [stepControl]="formDoppiaMaterialitaCheckId" [editable]="true">
      <ng-template matStepLabel> Validazione IRO </ng-template>

      <div
        class="barra-titolo-cruscotto"
        appFormContainer
        [larghezza]="2"
        [alignItems]="'flex-end'"
      >
        <div style="display: flex; flex-direction: column; flex: 1" appFormElement [larghezza]="2">
          <div class="titolo-sezione-dialog">
            Cruscotto di Validazione Impatti, Rischi e Opportunità
          </div>

          <div class="descrizione-sezione-dialog">
            Visualizza e gestisci ogni aspetto relativo alla validazione: stato, configurazione dei
            testi mail, invio e notifiche
          </div>
        </div>

        <div
          class="stato-validazione"
          appFormElement
          [larghezza]="'auto'"
          [minWidth]="200"
          [ngStyle]="{
            'border-color':
              statiDm[this.formDoppiaMaterialita.get('statoDm')?.value || 'NON_INVIATO']?.colore,
            color:
              statiDm[this.formDoppiaMaterialita.get('statoDm')?.value || 'NON_INVIATO']?.colore,
          }"
        >
          <div class="titolo-stato-dm">
            {{
              statiDm[this.formDoppiaMaterialita.get('statoDm')?.value || 'NON_INVIATO']?.nome || ''
            }}
          </div>

          @if (
            statiDm[this.formDoppiaMaterialita.get('statoDm')?.value || 'NON_INVIATO']?.sottotitolo
          ) {
            <div class="sottotitolo">
              {{
                statiDm[this.formDoppiaMaterialita.get('statoDm')?.value || 'NON_INVIATO']
                  ?.sottotitolo
              }}
            </div>
          } @else if (numeroNotificheInviate > 0) {
            <div class="notifiche">
              {{ numeroNotificheInviate }}
              {{ numeroNotificheInviate > 1 ? 'notifiche inviate' : 'notifica inviata' }}
            </div>
          }
        </div>

        <div
          class="dwn-versione"
          appFormElement
          [larghezza]="'auto'"
          [minWidth]="200"
          [riempi]="true"
        >
          <mat-form-field class="input-form no-subscript">
            <mat-label>Versioni</mat-label>
            <mat-select #revisioni placeholder="Versioni" [formControl]="formVersione">
              <mat-option *ngFor="let versione of versioni" [value]="versione.versione">
                Rev. n.{{ versione.versione }} del
                {{ versione.dataPubblicazione | date: 'dd/MM/YYYY' }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <button
            class="btn-download"
            [disabled]="!revisioni.value || isArchiviato()"
            mat-flat-button
            color="accent"
            (click)="downloadVersione()"
          >
            <mat-icon matSuffix>download</mat-icon>
          </button>
        </div>

        <!-- TOTALI CRUSCOTTO -->
        @if (this.formDoppiaMaterialita.get('id')?.value) {
          <app-totali-cruscotto
            #totaliCruscottoValidatori
            [idModulo]="this.formDoppiaMaterialita.get('id')?.value"
            [tipoModulo]="'DOPPIA_MATERIALITA'"
            [isIro]="true"
          >
          </app-totali-cruscotto>
        }
      </div>

      <ng-scrollbar>
        <div style="padding-right: 15px">
          <app-lista-tabellare
            #tabellaValidatori
            [defaultPageSize]="4"
            [fnCaricamentoDati]="fnCaricamentoValidatori"
            [colonne]="colonneValidatori"
            [maxNrButton]="1"
            [filtri]="filtri"
            (bottoniListaClick)="bottoniListaValidatoriClick($event)"
            *ngIf="this.formDoppiaMaterialita.get('id')?.value"
          >
            <ng-container btnEnd>
              <button
                [disabled]="!isPermessoInvioMail"
                mat-flat-button
                class="primary-button"
                color="primary"
                (click)="templateValidatori()"
              >
                <mat-icon matSuffix>settings</mat-icon>
                Config. Testi
              </button>

              <button
                [disabled]="!isPermessoInvioMail"
                mat-flat-button
                class="primary-button"
                color="primary"
                (click)="inviaTuttiValidatori()"
                [disabled]="this.formDoppiaMaterialita.get('statoDm')?.value === 'APPROVATO'"
              >
                <mat-icon matSuffix>mail</mat-icon>
                Invia a Tutti
              </button>

              <button
                [disabled]="!isPermessoInvioMail"
                mat-flat-button
                class="primary-button"
                color="primary"
                (click)="notificaTuttiValidatori()"
                [disabled]="this.formDoppiaMaterialita.get('statoDm')?.value === 'APPROVATO'"
              >
                <mat-icon matSuffix>notifications_active</mat-icon>
                Notifica Tutti
              </button>
            </ng-container>
          </app-lista-tabellare>
        </div>
      </ng-scrollbar>
    </mat-step>

    <!-- ? CREAZIONE STAKEHOLDER INTERNI -->
    <mat-step [errorMessage]="'Peso diverso da 100'" [stepControl]="formStepInterni">
      <ng-template matStepLabel> SH interni </ng-template>

      <div style="height: 10px"></div>
      <app-seleziona-stakeholders
        [tipo]="'INTERNI'"
        #stInterni
        [idMaterialita]="this.formDoppiaMaterialita.get('id')?.value"
        [disabled]="isPubblicato() || isArchiviato()"
        [gestionePeso]="true"
        [mostraTutorial]="false"
        [pesoPerStakeholder]="true"
        [getStakeholdersFn]="getStakeholders"
        [fatturato]="fatturato"
        [nrDipendenti]="nrDipendenti"
        [salvaStakeholdersFn]="salvaStakeholders"
        [gestioneSceltaCampione]="true"
      >
        <div class="titolo-sezione-dialog">Valutazione: selezione stakeholder interni</div>

        <div class="descrizione-sezione-dialog" appFormContainer [larghezza]="3" [gap]="20">
          <div appFormElement [larghezza]="2">
            Definisci il peso delle tipologie di Stakeholder Interni ed Esterni tramite l’apposito
            slider. Seleziona gli stakeholder interni da coinvolgere nell’analisi e definiscine il
            grado di rilevanza attribuendo un peso a ciascuna categoria e dei singoli componenti
            della categoria. Ricorda che il peso complessivo dovrà essere pari a 100. Motiva la
            scelta del campione da coinvolgere per la valutazione.
          </div>

          <div
            class="container-peso-sh bordo-chiaro"
            appFormElement
            [larghezza]="1"
            [riempi]="true"
          >
            <ng-container
              [ngTemplateOutlet]="sliderSh"
              [ngTemplateOutletContext]="{ tipologia: 'interni', componente: stEsterni }"
            >
            </ng-container>
          </div>
        </div>
      </app-seleziona-stakeholders>
    </mat-step>

    <!-- ? CREAZIONE STAKEHOLDER ESTERNI -->
    <mat-step [errorMessage]="'Peso diverso da 100'" [stepControl]="formStepEsterni">
      <ng-template matStepLabel> SH esterni </ng-template>
      <div style="height: 10px"></div>
      <app-seleziona-stakeholders
        [tipo]="'ESTERNI'"
        #stEsterni
        [idMaterialita]="this.formDoppiaMaterialita.get('id')?.value"
        [disabled]="isPubblicato() || isArchiviato()"
        [gestionePeso]="true"
        [mostraTutorial]="false"
        [pesoPerStakeholder]="true"
        [getStakeholdersFn]="getStakeholders"
        [fatturato]="fatturato"
        [nrDipendenti]="nrDipendenti"
        [salvaStakeholdersFn]="salvaStakeholders"
        [gestioneSceltaCampione]="true"
      >
        <div class="titolo-sezione-dialog">Valutazione: selezione stakeholder esterni</div>

        <div class="descrizione-sezione-dialog" appFormContainer [larghezza]="3">
          <div appFormElement [larghezza]="2">
            Definisci il peso delle tipologie di Stakeholder Interni ed Esterni tramite l’apposito
            slider. Seleziona gli stakeholder esterni da coinvolgere nell’analisi e definiscine il
            grado di rilevanza attribuendo un peso a ciascuna categoria e dei singoli componenti
            della categoria. Ricorda che il peso complessivo dovrà essere pari a 100. Motiva la
            scelta del campione da coinvolgere per la valutazione.
          </div>

          <div
            class="container-peso-sh bordo-chiaro"
            appFormElement
            [larghezza]="1"
            [riempi]="true"
          >
            <ng-container
              [ngTemplateOutlet]="sliderSh"
              [ngTemplateOutletContext]="{ tipologia: 'esterni', componente: stEsterni }"
            >
            </ng-container>
          </div>
        </div>
      </app-seleziona-stakeholders>
    </mat-step>

    <!-- --------------------  Assegnazione IRO -------------------->
    <mat-step>
      <ng-template matStepLabel> Assegnazione IRO </ng-template>

      <div class="titolo-sezione-dialog">Valutazione: Assegnazione IRO</div>

      <div class="descrizione-sezione-dialog" appFormContainer [larghezza]="3">
        Assegna la valutazione di Impatti, Rischi e Opportunità ai tuoi stakeholder e motiva le
        scelte fatte.

        @if (tabAssegnIro.selectedIndex === 3) {
          <div>
            <strong>Nota:</strong> Motivare l’assegnazione degli IRO non è obbligatorio per la tua
            azienda ma è raccomandato per le aziende che dovranno intrapendere il percorso di
            assurance.
          </div>
        }
      </div>
      <div class="mat-tab-iro">
        <mat-tab-group #tabAssegnIro>
          <mat-tab label="Impatti">
            <app-assegnazione-iro
              [arrayIdElementiAssegnati]="arrayIdElementiAssegnati"
              [doppiaSurvey]="doppiaSurvey"
              tipoIRO="impattiIro"
            ></app-assegnazione-iro>
          </mat-tab>

          <mat-tab label="Rischi">
            <app-assegnazione-iro
              [arrayIdElementiAssegnati]="arrayIdElementiAssegnati"
              [doppiaSurvey]="doppiaSurvey"
              tipoIRO="rischi"
            ></app-assegnazione-iro>
          </mat-tab>

          <mat-tab label="Opportunità">
            <app-assegnazione-iro
              [arrayIdElementiAssegnati]="arrayIdElementiAssegnati"
              [doppiaSurvey]="doppiaSurvey"
              tipoIRO="opportunita"
            ></app-assegnazione-iro>
          </mat-tab>

          <mat-tab label="Criteri per l'assegnazione">
            <div style="flex: 1">
              <ng-scrollbar>
                @if (criteriPerAssegnazione.length) {
                  <div class="cnt-categorie">
                    @for (criterio of criteriPerAssegnazione; track criterio.id) {
                      <div class="testata-categoria">
                        <div style="align-items: center; display: flex">
                          Categoria Stakeholder
                          {{ criterio.tipologia === 'ESTERNI' ? 'Esterno' : 'Interno' }} :
                          {{ criterio.titolo }}
                        </div>

                        <div class="button-with-badge">
                          <button
                            class="custom-button"
                            (click)="openDialogCriteriAssegnazioneIRO(criterio)"
                          >
                            Criterio di Assegnazione
                          </button>
                          @if (criterio.criteriDiAssegnazione) {
                            <div class="badge">✔</div>
                          }
                        </div>
                      </div>

                      <div class="assegna-iro">
                        <app-assegnazione-iro
                          [doppiaSurvey]="criterio.doppiaSurvey"
                          [isTabCriteri]="true"
                        ></app-assegnazione-iro>
                      </div>
                    }
                  </div>
                }
              </ng-scrollbar>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </mat-step>

    <!--------------------------- CRUSCOTTO SURVEY ----------------- -->

    <mat-step [stepControl]="ctrCruscottoStepControl()">
      <ng-template matStepLabel> Cruscotto Survey </ng-template>

      <div class="barra-titolo-cruscotto">
        <div style="display: flex; flex-direction: column; flex: 1">
          <div class="titolo-sezione-dialog">Cruscotto Survey</div>

          <div class="descrizione-sezione-dialog">
            Visualizza e gestisci ogni aspetto relativo alla compilazione: avanzamento,
            configurazione dei testi mail, invio e notifiche.
          </div>
        </div>

        <!-- TOTALI CRUSCOTTO FINALE -->
        @if (this.formDoppiaMaterialita.get('id')?.value) {
          <app-totali-cruscotto
            #totaliCruscottoFinale
            [idModulo]="this.formDoppiaMaterialita.get('id')?.value"
            [tipoModulo]="'DOPPIA_MATERIALITA'"
          >
          </app-totali-cruscotto>
        }
      </div>

      <ng-scrollbar>
        <div style="padding-right: 15px">
          <app-lista-tabellare
            #tabellaSurvey
            [defaultPageSize]="4"
            [fnCaricamentoDati]="fnCaricamentoDatiTabellaSurvey"
            [colonne]="colonneSurvey"
            [maxNrButton]="1"
            [filtri]="filtri"
            (bottoniListaClick)="bottoniListaClick($event)"
            *ngIf="this.formDoppiaMaterialita.get('id')?.value"
          >
            <ng-container btnEnd>
              <button
                [disabled]="!isPermessoInvioMail"
                mat-flat-button
                class="primary-button"
                color="primary"
                (click)="templateDoppiaSurvey()"
              >
                <mat-icon matSuffix>settings</mat-icon>
                Config. Testi
              </button>

              <button
                [disabled]="!isPermessoInvioMail"
                mat-flat-button
                class="primary-button"
                color="primary"
                (click)="inviaTuttiDoppiaSurvey()"
                [disabled]="this.formDoppiaMaterialita.get('dataUltimaConferma')?.value"
              >
                <mat-icon matSuffix>mail</mat-icon>
                Invia a Tutti
              </button>

              <button
                [disabled]="!isPermessoInvioMail"
                mat-flat-button
                class="primary-button"
                color="primary"
                (click)="notificaTuttiDoppiaSurvey()"
                [disabled]="this.formDoppiaMaterialita.get('dataUltimaConferma')?.value"
              >
                <mat-icon matSuffix>notifications_active</mat-icon>
                Notifica Tutti
              </button>

              <button
                [disabled]="!isPermessoInvioMail"
                mat-flat-button
                class="primary-button"
                color="primary"
                (click)="apriRiepilogoInvioMail()"
              >
                <mat-icon matSuffix>summarize</mat-icon>
                Riepilogo Invii
              </button>

              <form appFormContainer [larghezza]="4" [formGroup]="formCruscottoSurvey">
                <div class="scadenza-survey">
                  <mat-form-field appFormElement [larghezza]="1" [riempi]="true">
                    <mat-label>Data di Scadenza Survey</mat-label>
                    <input
                      matInput
                      [matDatepicker]="picker"
                      [min]="minDate"
                      formControlName="scadenzaSurvey"
                    />
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <mat-error appFormError></mat-error>
                  </mat-form-field>
                </div>
              </form>
            </ng-container>
          </app-lista-tabellare>
        </div>
      </ng-scrollbar>
    </mat-step>

    <!-- Analisi IRO Materiali -->
    <mat-step>
      <ng-template matStepLabel> Analisi </ng-template>

      <div class="titolo-sezione-dialog">Analisi</div>

      <div class="main-cont-analisi" appFormContainer [gap]="20" [larghezza]="4">
        <div class="cont-soglie" appFormElement [larghezza]="1" [minWidth]="300">
          <div class="titolo-sez">Definizione Soglie di Materialità</div>

          <div [formGroup]="formDoppiaMaterialita" class="valori-soglie bordo-chiaro">
            <ng-scrollbar [visibility]="'hover'">
              <div class="lista-soglie">
                <ng-container
                  [ngTemplateOutlet]="sliderSoglia"
                  [ngTemplateOutletContext]="{
                    control: formSoglie.get('sogliaImpatti'),
                    titolo: 'Soglia Materialità Impatti',
                  }"
                >
                </ng-container>

                <ng-container
                  [ngTemplateOutlet]="sliderSoglia"
                  [ngTemplateOutletContext]="{
                    control: formSoglie.get('sogliaRischi'),
                    titolo: 'Soglia Materialità Rischi',
                  }"
                >
                </ng-container>

                <ng-container
                  [ngTemplateOutlet]="sliderSoglia"
                  [ngTemplateOutletContext]="{
                    control: formSoglie.get('sogliaOpportunita'),
                    titolo: 'Soglia Materialità Opportunità',
                  }"
                >
                </ng-container>

                <div class="tipo-sett">
                  <div class="titolo-sett">Tipologia di visualizzazione</div>

                  <mat-radio-group
                    class="radio-tipo-sett"
                    aria-label="Tipo visualizzazione"
                    [formControl]="tipoVisualizzazioneIroAnalisi"
                    (change)="cambiaTipoVisImpattiMateriali($event)"
                  >
                    <mat-radio-button aria-label="Solo IRO Materiali" value="MATERIALI">
                      Solo IRO materiali
                    </mat-radio-button>
                    <mat-radio-button aria-label="Tutti gli IRO" value="TUTTI">
                      Tutti gli IRO
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>
            </ng-scrollbar>
          </div>
        </div>

        <div class="cont-materiali" appFormElement [larghezza]="1" [riempi]="true">
          <div class="titolo-sez">IRO materiali</div>

          <div class="valori-materiali bordo-chiaro">
            <ng-scrollbar [visibility]="'hover'">
              <!-- Impatti -->
              <ng-container
                [ngTemplateOutlet]="listaIroMateriali"
                [ngTemplateOutletContext]="{
                  listaIro: impattiCompilatiFiltrati,
                  nomeIro: 'Impatti',
                  soglia: formSoglie.get('sogliaImpatti')?.value || 0,
                }"
              >
              </ng-container>

              <!-- Rischi -->
              <ng-container
                [ngTemplateOutlet]="listaIroMateriali"
                [ngTemplateOutletContext]="{
                  listaIro: rischiCompilatiFiltrati,
                  nomeIro: 'Rischi',
                  soglia: formSoglie.get('sogliaRischi')?.value || 0,
                }"
              >
              </ng-container>

              <!-- Opportunità -->
              <ng-container
                [ngTemplateOutlet]="listaIroMateriali"
                [ngTemplateOutletContext]="{
                  listaIro: opportunitaCompilatiFiltrati,
                  nomeIro: 'Opportunità',
                  soglia: formSoglie.get('sogliaOpportunita')?.value || 0,
                }"
              >
              </ng-container>
            </ng-scrollbar>
          </div>
        </div>
      </div>
    </mat-step>
  </mat-stepper>
</div>

@if (stepper.selectedIndex === 9) {
  <div mat-dialog-actions class="dialog-footer-cont" *ngIf="stepper.selectedIndex === 9">
    <div>
      <button mat-flat-button color="accent" (click)="indietro()" class="accent-button">
        Indietro
      </button>
    </div>
    <div>
      <button mat-flat-button color="accent" (click)="stampa()" class="accent-button">
        <mat-icon>print</mat-icon>
        Stampa
      </button>
    </div>
    <div>
      <button
        mat-flat-button
        color="accent"
        class="accent-button"
        (click)="exportAnalisiRisultati()"
      >
        Esporta
        <mat-icon> file_download </mat-icon>
      </button>
    </div>

    <div>
      @if (isPermessoSoloRead) {
        <button matDialogClose mat-flat-button color="accent" class="accent-button">Chiudi</button>
      } @else {
        <button
          mat-flat-button
          color="primary"
          (click)="confermaHTML()"
          class="primary-button"
          #btnAvanti
        >
          Conferma
        </button>
      }
    </div>

    @if (formDoppiaMaterialita.get('dataUltimaConferma')?.value) {
      <div style="font-size: 14px">
        Ultima conferma : {{ formDoppiaMaterialita.get('dataUltimaConferma')?.value }}
      </div>
    }
  </div>
} @else {
  <div mat-dialog-actions class="dialog-footer-cont">
    <div>
      <button
        mat-flat-button
        color="accent"
        [disabled]="stepper.selectedIndex === 0"
        (click)="indietro()"
        class="accent-button"
      >
        Indietro
      </button>
    </div>
    <div>
      <button
        mat-flat-button
        color="primary"
        (click)="avantiHTML()"
        class="primary-button"
        #btnAvanti
      >
        Avanti
      </button>
    </div>
  </div>
}

<ng-template
  #temaEsrs
  let-ambito="ambito"
  let-tematica="tematica"
  let-tema="tema"
  let-livello="livello"
  let-padri="padri"
>
  <!-- ELEMENTO PER TEMI STEP IRO -->
  <div>
    <div
      class="tema"
      [class.dettaglio]="tema.includi"
      [style]="{ '--indentazione': 16 + 30 * livello + 'px' }"
    >
      <div class="nome-tema">
        <span class="etichetta-esrs">{{ getEtichettaESRS(livello) }}</span> {{ tema.nomeBreve }}
        {{ tema.descrizione ? ' - ' + tema.descrizione : '' }}
      </div>

      @if (tema.includi) {
        <ng-container
          [ngTemplateOutlet]="bottoni"
          [ngTemplateOutletContext]="{ ambito, tematica, tema, padri }"
        >
        </ng-container>
      }
    </div>

    @if (!tema.includi && tema.sottoTemi?.length) {
      <div class="sottotemi">
        @for (sottotema of tema.sottoTemi; track sottotema.id) {
          <ng-container
            [ngTemplateOutlet]="temaEsrs"
            [ngTemplateOutletContext]="{
              ambito,
              tematica,
              tema: sottotema,
              livello: livello + 1,
              padri: (padri || []).concat(tema),
            }"
          >
            <!-- Mi prendo i "padri" concatenando se stesso al successivo padre, questo perchè c'è una gestione ricorsiva e mi perdeva il padre precedente -->
          </ng-container>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #bottoni let-ambito="ambito" let-tematica="tematica" let-tema="tema" let-padri="padri">
  <div class="bottoni">
    <button
      mat-flat-button
      class="btn-iro"
      [matBadge]="(tema || tematica).iroNonValidati?.impatti"
      [matBadgeHidden]="(tema || tematica).iroNonValidati?.impatti <= 0"
      (click)="
        apriImpatti(
          ambito.id,
          tematica,
          tema?.id,
          tema ? tema.nomeBreve + (tema.descrizione ? ' - ' + tema.descrizione : '') : '',
          padri
        )
      "
    >
      Impatti
    </button>
    <button
      mat-flat-button
      class="btn-iro"
      [matBadge]="(tema || tematica).iroNonValidati?.rischi"
      [matBadgeHidden]="(tema || tematica).iroNonValidati?.rischi <= 0"
      (click)="
        apriRischi(
          ambito.id,
          tematica,
          tema?.id,
          tema ? tema.nomeBreve + (tema.descrizione ? ' - ' + tema.descrizione : '') : '',
          padri
        )
      "
    >
      Rischi
    </button>
    <button
      mat-flat-button
      class="btn-iro"
      [matBadge]="(tema || tematica).iroNonValidati?.opportunita"
      [matBadgeHidden]="(tema || tematica).iroNonValidati?.opportunita <= 0"
      (click)="
        apriOpportunita(
          ambito.id,
          tematica,
          tema?.id,
          tema ? tema.nomeBreve + (tema.descrizione ? ' - ' + tema.descrizione : '') : '',
          padri
        )
      "
    >
      Opportunità
    </button>
  </div>
</ng-template>

<ng-template #sliderSh let-tipologia="tipologia" let-componente="componente">
  <button
    mat-stroked-button
    color="accent"
    class="come-definire-peso-sh"
    (click)="componente.comeDefinireIlPeso()"
  >
    <div style="font-weight: bold">Come definire il peso degli stakeholder?</div>
  </button>

  <div class="slider-container">
    <div class="cont-slider-perc">
      <span>SH Interni</span>
      <div class="slider-perc">{{ formSliderInterni.value }} %</div>
    </div>
    <mat-slider
      min="0"
      max="100"
      step="1"
      color="accent"
      [ngClass]="tipologia"
      [disabled]="isPubblicato() || isArchiviato()"
    >
      @if (tipologia == 'esterni') {
        <input #inputThumb matSliderThumb [formControl]="formSliderEsterni" />
      } @else {
        <input #inputThumb matSliderThumb [formControl]="formSliderInterni" />
      }
    </mat-slider>
    <div class="cont-slider-perc">
      <span>SH Esterni</span>
      <div class="slider-perc">{{ 100 - formSliderEsterni.value }} %</div>
    </div>
  </div>
  <!--  <div class="slider-perc">
        @if(tipologia == 'esterni'){
        {{100 - formSliderEsterni.value}} %
        } @else {
        {{formSliderInterni.value}} %
        }
    </div> -->
</ng-template>

<ng-template #sliderSoglia let-titolo="titolo" let-control="control">
  <div class="slider-soglie">
    <div>
      {{ titolo }}
    </div>
    <div class="slider-container">
      <span>0</span>
      <mat-slider min="0" max="5" step="0.1" color="accent" [disabled]="isArchiviato()">
        <input #inputThumb matSliderThumb [formControl]="control" />
      </mat-slider>
      <span>5</span>
    </div>
    <div class="slider-val">
      {{ control.value }}
    </div>
  </div>
</ng-template>

<ng-template #listaIroMateriali let-listaIro="listaIro" let-nomeIro="nomeIro" let-soglia="soglia">
  <div>
    <div class="header-iro" appFormContainer [wrap]="false" [larghezza]="3" [alignItems]="'center'">
      <div appFormElement [larghezza]="1" [riempi]="true">{{ nomeIro }}</div>
      <div appFormElement [larghezza]="'auto'" [minWidth]="100">Punteggio</div>
    </div>
    @for (iro of listaIro; track $index) {
      <div
        class="riga-iro"
        [class.materiale]="iro.mediaPesata >= soglia"
        appFormContainer
        [wrap]="false"
        [larghezza]="3"
        [alignItems]="'center'"
      >
        <div class="testi-iro" appFormElement [larghezza]="1" [riempi]="true">
          <div class="titolo-iro">
            {{ iro.titolo || iro.descrizione }}
            @if (iro.mediaPesata >= soglia) {
              <!-- IRO MATERIALE -->
              <span>
                <mat-icon class="icona-check">check</mat-icon>
              </span>
            }
          </div>
          <div class="info-iro">
            {{ iro.stringaIro }}
          </div>
        </div>
        <div class="punteggio" appFormElement [larghezza]="'auto'" [minWidth]="100">
          {{ iro.mediaPesata }}
        </div>
      </div>
    } @empty {
      <div class="no-data">Nessun dato trovato</div>
    }
  </div>
</ng-template>
